export class StoreChecklistParams {
    CatDetStoreTypeId: number;
    CatDetTradeMarkId: number;
    OpeningTime: String;
    ClosingTime: String;
    OrganizationId: String;
    CatDetCountryId: Number;
}
